//For dev
// const baseHost = "https://psl-dev-webapp-uksouth-ecb4bcaabsd9gufn.uksouth-01.azurewebsites.net/";

//For Local
//const baseHost = "https://localhost:5001/";

//For Prod
const baseHost = "https://fds-prod-webapp-uksouth-g6h2gwhxbhcafzc2.uksouth-01.azurewebsites.net/";

const getClientNameFromPath = () => {
  try {
    const match = window.location.pathname.match(/^\/client\/([^/]+)/i);
    return match?.[1] || "";
  } catch {
    return "";
  }
};

const clientName = getClientNameFromPath();

// If clientName exists, append /Client/{clientName}; else return base
export const hostName = clientName
  ? `${baseHost}/client/${encodeURIComponent(clientName)}`
  : baseHost;
